<template>
  <!-- Card -->
  <div class="channel-card" :class="{'public': channel.privacy === privacy.Public}" @click="handleClick">
    <a-image
        :alt-text="channel.name"
        :image-path="channel.imagePath"
        :size="channelCardSize"
        :rounded="true"
    />
    <div class="channel-card-content">
      <template v-if="channel.privacy === privacy.Public">
        <a-router-link-channel-view :channel-slug="channel.slug">
          <h6 class="channel-card-title">
            {{ channel.name }}
          </h6>
        </a-router-link-channel-view>
      </template>
      <template v-else>
        <h6 class="channel-card-title">
          {{ channel.name }}
        </h6>
      </template>

      <div class="channel-card-privacy">
        <template v-if="channel.privacy === privacy.Public">
          <img src="../../../../assets/landing-pages/new/icons/public-icon.svg" alt=""
               class="channel-card-privacy-icon">
          Open channel
        </template>
        <template v-else>
          <img src="../../../../assets/landing-pages/new/icons/private-icon.svg"
               alt="Private Liffery Channel"
               class="channel-card-privacy-icon">
          Private channel
        </template>
      </div>
    </div>
    <img src="../../../../assets/landing-pages/new/icons/add-new.svg" alt="" class="channel-card-add-icon">
  </div>
</template>

<style scoped lang="scss">
.channel-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.412rem;
  max-width: 29.4rem;
  background-color: $white;
  border-radius: var(--radius-big);
  box-shadow: $box-shadow-size $box-shadow-color;
  cursor: not-allowed;

  &.public {
    cursor: pointer;
  }

  &-content {
    flex-grow: 1;
    margin-left: 1.412rem;
    text-align: left;
  }

  &-title {
    margin-bottom: .47rem;
  }

  &-privacy {
    font-size: .941rem;
    color: $greyDarkest;
  }
}
</style>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Datum } from '@/api/ms-channel/services/interfaces/PublicChannels';
import AImage from '@/components/atoms/AImage.vue';
import { Size } from '@/api/ms-image-server-cache/services/interfaces/ImageTypeDirectorySizeFileNameGetPath';
import { AuthenticationStore } from '@/store';
import ARouterLinkChannelView from '@/components/atoms/link/ARouterLinkChannelView.vue';
import { Privacy } from '@/api/ms-channel/services/interfaces/Channel';
import getChannelRouterObject from '@/utils/getChannelRouterObject';

@Component({
  components: { ARouterLinkChannelView, AImage }
})
export default class OCaptureAndConsider extends Vue {

  @Prop({ required: true })
  channel!: Datum;

  privacy = Privacy;

  channelCardSize = Size.The60X60;

  handleClick () {
    if (this.channel.privacy === Privacy.Public) {
      this.$router.push(
        getChannelRouterObject(
          this.channel.slug
        )
      );
    } else {
      this.loginPrompt();
    }
  }

  loginPrompt () {
    AuthenticationStore.TOGGLE_PROMPT_LOGIN({ state: true });
  }
}
</script>
